export const LIFECYCLE_STAGES = {
  BUILD: 'build',
  SETTINGS: 'settings',
  PUBLISH: 'publish',
  INVITE: 'invite',
} as const;

export const ACCESS_LEVEL = {
  OVERRIDE: 'OVERRIDE',
  ALLOW: 'ALLOW',
  DENY: 'DENY',
} as const;

/* to be removed */
export const SERIES_ACTION_TYPES = {
  EDIT_COLLABORATOR_SETTINGS: 'EDIT_COLLABORATOR_SETTINGS',
  INVITE_AND_REMOVE_LEARNERS: 'INVITE_AND_REMOVE_LEARNERS',
  INVITE_AND_REMOVE_USER_GROUPS: 'INVITE_AND_REMOVE_USER_GROUPS',
} as const;

export const GAME_ACTION_TYPES = {
  CREATE: 'CREATE_GAME',
  ARCHIVE: 'ARCHIVE_GAME',
  DELETE: 'DELETE_GAME',
  DUPLICATE: 'DUPLICATE_GAME',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
  PUBLISH_AND_UPDATE: 'PUBLISH_AND_UPDATE',
} as const;

/* to be removed */

export const MT_SERIES_MODULES = {
  ASSESSMENT: 5,
  CHECKLIST: 7,
  COACHING: 6,
  COURSE: 2,
  ILT: 8,
  MISSION: 4,
  QUICKUPDATE: 3,
} as const;

export const MT_MODULES = {
  ...MT_SERIES_MODULES,
  ONE_TO_ONE_COACHING: 13,
  REINFORCEMENT: 14,
  SCREEN_CAPTURE_COACHING: 12,
  TASK_EVALUATION_COACHING: 11,
  VIDEO_PITCH_COACHING: 10,
  VOICE_OVER_PPT_COACHING: 9,
  PERFORMANCE_EVALUATION_COACHING: 15, // To be deprecated once it is replaced with COMPETENCY_ASSESSMENT
  COMPETENCY_ASSESSMENT: 15,
  VOICE_OVER_IMAGE_CONTENT: 16,
} as const;

export const MT_MODULES_MAP = {
  [MT_MODULES.ASSESSMENT]: 'Assessment',
  [MT_MODULES.CHECKLIST]: 'Checklist',
  [MT_MODULES.COACHING]: 'Coaching',
  [MT_MODULES.COURSE]: 'Course',
  [MT_MODULES.ILT]: 'ILT',
  [MT_MODULES.MISSION]: 'Mission',
  [MT_MODULES.ONE_TO_ONE_COACHING]: 'One to one coaching',
  [MT_MODULES.QUICKUPDATE]: 'Quick Update',
  [MT_MODULES.REINFORCEMENT]: 'Quest',
  [MT_MODULES.SCREEN_CAPTURE_COACHING]: 'Screen capture',
  [MT_MODULES.TASK_EVALUATION_COACHING]: 'Email and task evaluation',
  [MT_MODULES.VIDEO_PITCH_COACHING]: 'Video roleplay',
  [MT_MODULES.VOICE_OVER_PPT_COACHING]: 'Voice over slideshow',
  [MT_MODULES.VOICE_OVER_IMAGE_CONTENT]: 'Voice over image content',
  [MT_MODULES.COMPETENCY_ASSESSMENT]: 'Competency assessment',
} as const;

export const POLLING_STATUS = {
  CREATED: 0,
  INGESTED: 1,
  SCHEDULED: 2,
  PROCESSING: 3,
  FAILED: 4,
  TIMEDOUT: 5,
  RETRYSCHEDULED: 6,
  SUCCESS: 7,
  CREATIONFAILE: 8,
  RUNNING: 3,
  //new status code changes
  CONTEXT_CREATED: 0,
  CONTEXT_PROCESSING: 3,
  CONTEXT_FAILED: 4,
  CONTEXT_SUCCESS: 7,
} as const;
